import { Grid } from "@dealer-center/core-components";
import type { CompareToolContentItemsProps } from "./interface";
import { CompareToolContentItem } from "./useCompareToolContenItem";
export const CompareToolContentItems = ({
  label,
  from,
  to
}: CompareToolContentItemsProps) => {
  return (
    <Grid container key={label} spacing={2}>
      <CompareToolContentItem label={label} value={from} />
      <CompareToolContentItem label={label} value={to} />
    </Grid>
  );
};
